import React from 'react'
import { Alert, Card, Flex, Typography } from 'antd'
import { useUnit } from 'effector-react'

import { GUARD_RULES } from 'src/features/session/constants'
import { Guard } from 'src/features/session/guard'
import { AddressCheckForm } from './widgets/AddressCheckForm'
import { AddressResult } from './widgets/AddressResult'
import { TxidCheckForm } from './widgets/TxidCheckForm'
import { TransactionResult } from './widgets/TransactionResult'
import {
  $errorMessage,
  $checkTransactionHashResult,
  $addressErrorMessage,
  $checkAddressResult,
  amlCheckRefreshRequested,
  transactionHashCheckSubmitted,
  addressCheckSubmitted,
  addressCheckRefreshRequested,
  checkTransactionHashFx,
  refreshAmlCheckFx,
  checkAddressFx,
  refreshAddressCheckFx,
} from './model'

export const WalletGuardCheckPage = () => {
  const {
    checkTransactionHashResult,
    errorMessage,
    loading,
    amlCheckRefreshing,
    onSubmit,
    onAmlCheckRefresh,
    checkAddressResult,
    addressErrorMessage,
    addressLoading,
    addressCheckRefreshing,
    onAddressSubmit,
    onAddressCheckRefresh,
  } = useUnit({
    checkTransactionHashResult: $checkTransactionHashResult,
    errorMessage: $errorMessage,
    loading: checkTransactionHashFx.pending,
    amlCheckRefreshing: refreshAmlCheckFx.pending,
    onSubmit: transactionHashCheckSubmitted,
    onAmlCheckRefresh: amlCheckRefreshRequested,
    checkAddressResult: $checkAddressResult,
    addressErrorMessage: $addressErrorMessage,
    addressLoading: checkAddressFx.pending,
    addressCheckRefreshing: refreshAddressCheckFx.pending,
    onAddressSubmit: addressCheckSubmitted,
    onAddressCheckRefresh: addressCheckRefreshRequested,
  })

  return (
    <Flex vertical gap={24}>
      <Typography.Title level={1} style={{ margin: 0 }}>
        Проверка
      </Typography.Title>

      <Guard permission={GUARD_RULES.CHECK_CRYPTO_WALLET} mode="permission">
        <Card title={<strong>Проверка адреса</strong>}>
          <Flex vertical gap={16}>
            <AddressCheckForm
              onSubmit={onAddressSubmit}
              loading={addressLoading}
            />

            {addressErrorMessage && (
              <Alert type="error" showIcon message={addressErrorMessage} />
            )}

            {checkAddressResult && (
              <AddressResult
                check={checkAddressResult}
                refreshing={addressCheckRefreshing}
                hasError={addressErrorMessage !== null}
                onRefresh={() => onAddressCheckRefresh(checkAddressResult)}
              />
            )}
          </Flex>
        </Card>
      </Guard>

      <Guard
        permission={GUARD_RULES.CHECK_CRYPTO_TRANSACTION}
        mode="permission"
      >
        <Card title={<strong>Проверка транзакции по хешу</strong>}>
          <TxidCheckForm onSubmit={onSubmit} loading={loading} />
        </Card>

        {errorMessage && <Alert type="error" showIcon message={errorMessage} />}

        {checkTransactionHashResult && (
          <Card title={<strong>Результат проверки</strong>}>
            <TransactionResult
              result={checkTransactionHashResult}
              amlCheckRefreshing={amlCheckRefreshing}
              hasError={errorMessage !== null}
              onAmlCheckRefresh={() =>
                onAmlCheckRefresh(checkTransactionHashResult)
              }
            />
          </Card>
        )}
      </Guard>
    </Flex>
  )
}
